'use client';
import React from 'react';
import Head from 'next/head';
import { useChatbotVisibility } from '@/hooks/useChatbotVisibility';

const Ada = () => {
  const region = process.env.NEXT_PUBLIC_REGION;
  const { isDisabled } = useChatbotVisibility();
  function getAdaScriptEnvironment(domain: string | undefined) {
    switch (domain) {
      case 'lovevery.com':
        return 'lovevery-nam-gr';
      default:
        return 'sandbox-lovevery-gr';
    }
  }
  if (isDisabled) return null;

  if (region === 'US') {
    return (
      <Head>
        <script
          async
          id="__ada"
          data-handle={getAdaScriptEnvironment(
            process.env.NEXT_PUBLIC_BACKEND_DOMAIN,
          )}
          src="https://static.ada.support/embed2.js"
        />
      </Head>
    );
  }

  return null;
};

export default Ada;
